import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';
import styles from './FormRow.module.css';

export interface FormRowProps {
  label?: ReactNode;
  helper?: ReactNode;
  required?: boolean;
  fullWidth?: boolean;
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Two-column form layout: label column + input column. Use `fullWidth` for
 * inputs that should span both columns (e.g. notes textarea).
 */
export function FormRow({
  label,
  helper,
  required,
  fullWidth = false,
  htmlFor,
  children,
  className,
}: FormRowProps) {
  return (
    <div className={cn(styles.row, fullWidth && styles.fullWidth, className)}>
      {!fullWidth && label !== undefined ? (
        <div className={styles.labelCol}>
          {htmlFor ? (
            <label htmlFor={htmlFor}>
              {label}
              {required ? (
                <span className={styles.required} aria-hidden>
                  *
                </span>
              ) : null}
            </label>
          ) : (
            <span>
              {label}
              {required ? (
                <span className={styles.required} aria-hidden>
                  *
                </span>
              ) : null}
            </span>
          )}
          {helper ? <div className={styles.helper}>{helper}</div> : null}
        </div>
      ) : null}
      <div className={styles.controlCol}>{children}</div>
    </div>
  );
}
